import Cookie from 'js-cookie';
import { v4 as uuidv4 } from 'uuid';

class Latch {

    constructor() {
        this.tabID = sessionStorage.tabID ? sessionStorage.tabID : sessionStorage.tabID = uuidv4();
        try {
            if(Cookie.get('jb-latches-' + this.tabID))
                this.latches = JSON.parse(Cookie.get('jb-latches-' + this.tabID));
            else
                this.latches = {};
        } catch(e) {
            this.latches = {};
            this.save();
        }
    }

    save() {
        Cookie.set('jb-latches-' + this.tabID, JSON.stringify(this.latches));
    }

    has(name) {
        if(this.latches[name]) {
            return true;
        }
        return false;
    }

    did(name) {
        this.latches[name] = true;
        this.save();
    }

    reset(name) {
        if(this.latches[name]) {
            delete this.latches[name];
            this.save();
        } 
    }

}

var latch = new Latch();
export default latch;